import services from "@/http";
import * as types from "./mutation-types";
import { safeArray } from "@/helpers/functions/ArrayHelpers";

export const ActionGetAll = async ({ commit }, payload) => {
  try {
    const { data } = await services.pedidos.get_all(payload);
    commit(types.SET_PEDIDOS, data.data?.data || []);
    commit(types.SET_PAGINATION, data.data || {});
    commit(types.SET_ERROR, {});
    return data;
  } catch (error) {
    commit(types.SET_ERROR, error);
    throw error;
  }
};

export const ActionFind = async (store, payload) => {
  let response = { data: [], meta: {} };

  await services.pedidos.get_all(payload).then((res) => {
    response = res.data;
  });

  return response;
};

export const ActionResetPedido = ({ commit }) => {
  commit(types.SET_PEDIDO, {});
};

export const ActionResetPagamento = ({ commit }) => {
  commit(types.SET_PAGAMENTO, {});
};

export const ActionResetPagamentosHistorico = ({ commit }) => {
  commit(types.SET_PAGAMENTOS_HISTORICO, []);
};

export const ActionShow = async ({ commit }, id) => {
  try {
    const { data } = await services.pedidos.show({ id });
    commit(types.SET_PEDIDO, data);
    commit(types.SET_ERROR, {});
    return data;
  } catch (error) {
    commit(types.SET_ERROR, error);
    throw error;
  }
};

export const ActionShowPayment = async ({ commit }, id) => {
  try {
    const { data } = await services.pedidos.show_payment({ id });
    commit(types.SET_PAGAMENTO, data);
    commit(types.SET_ERROR, {});
    return data;
  } catch (error) {
    commit(types.SET_ERROR, error);
    throw error;
  }
};

export const ActionCancelOrder = async ({ commit }, { id, motivo }) => {
  try {
    const { data } = await services.pedidos.cancel_order({ id }, { motivo });
    commit(types.SET_PEDIDO, data.pedido);
    commit(types.SET_ERROR, {});
    return data;
  } catch (error) {
    commit(types.SET_ERROR, error);
    throw error;
  }
};

export const ActionShowPaymentsHistory = async ({ commit }, id) => {
  try {
    const { data } = await services.pedidos.show_payments_history({ id });
    const payload = data?.data || data;
    const pagamentosHistorico = safeArray(payload.pagamentos);

    commit(types.SET_PAGAMENTOS_HISTORICO, pagamentosHistorico);
    commit(types.SET_ERROR, {});
    return data;
  } catch (error) {
    commit(types.SET_ERROR, error);
    throw error;
  }
};

export const ActionSetPedidos = ({ commit }, payload) => {
  commit(types.SET_PEDIDOS, payload);
};

export const ActionSetPedido = ({ commit }, payload) => {
  commit(types.SET_PEDIDO, payload);
};

export const ActionSetPagamento = ({ commit }, payload) => {
  commit(types.SET_PAGAMENTO, payload);
};

export const ActionSetPagamentosHistorico = ({ commit }, payload) => {
  commit(types.SET_PAGAMENTOS_HISTORICO, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};
